import { generateQueryString } from "src/util/helper";
import { IAChatResponse } from "../interface/AI/IAChatResponse";
import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { FilesCategoryEnum } from "../enum/FilesCategoryEnum";

enum AIServiceEnum {
  rtbChat = "/rtb-chat"
}

export class AIService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/ai");
  }
  public rtbChat = async (newMessage: string, chatSessionId: number, fileCategory: FilesCategoryEnum): Promise<IAChatResponse> => await this.POST(`${AIServiceEnum.rtbChat}?${generateQueryString({ newMessage, chatSessionId, fileCategory })}`);

}
